export default function IconScholarQALogo({
  id,
  height = 52,
  width = 381,
}: {
  id?: string;
  height?: number;
  width?: number;
}) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox="0 0 421.03 57.41"
    >
      <path
        fill="#F0529C"
        d="M14.15,24.76h-7.07v-6.84h5.7c.76,0,1.38-.63,1.38-1.4v-5.79h6.73v7.19c0,3.78-3.01,6.84-6.73,6.84ZM7.07,25.46H0v6.84h5.7c.76,0,1.38.63,1.38,1.4v5.79h6.73v-7.19c0-3.78-3.01-6.84-6.73-6.84ZM29.68,25.11c-.76,0-1.38-.63-1.38-1.4v-5.79h-6.73v7.19c0,3.78,3.01,6.84,6.73,6.84h7.07v-6.84h-5.7ZM14.49,39.49v7.19h6.73v-5.79c0-.77.62-1.4,1.38-1.4h5.7v-6.84h-7.07c-3.72,0-6.73,3.06-6.73,6.84Z"
      />
      <path
        fill="#F0529C"
        d="M415.38,46.64l-3.17-8.5h-17.31l-3.17,8.5h-5.59l13.28-35.76h8.33l13.28,35.76h-5.65ZM396.56,33.68h13.98l-6.99-18.87-6.99,18.87Z"
      />
      <path
        fill="#F0529C"
        d="M346.73,28.31c0-5.52,1.49-9.96,4.46-13.33,3.01-3.37,7.6-5.05,13.77-5.05,4.12,0,7.54.79,10.27,2.37,2.72,1.58,4.73,3.71,6.02,6.4,1.29,2.65,1.94,5.68,1.94,9.09s-.75,6.4-2.26,8.87c-1.51,2.44-3.73,4.3-6.67,5.59h9.73v4.41h-19.03c-6.16,0-10.75-1.65-13.77-4.95-2.98-3.33-4.46-7.8-4.46-13.39ZM352.54,28.31c0,4.7.97,8.17,2.9,10.43,1.97,2.22,5.14,3.33,9.52,3.33s7.53-1.11,9.46-3.33c1.97-2.26,2.96-5.74,2.96-10.43s-.99-8.17-2.96-10.43c-1.94-2.26-5.09-3.39-9.46-3.39s-7.54,1.13-9.52,3.39c-1.93,2.26-2.9,5.74-2.9,10.43Z"
      />
      <path
        fill="#F0529C"
        d="M314.54,19.76h5.32v6.51c1.86-4.62,5.04-6.94,9.52-6.94h.81v5.22h-1.34c-3.41,0-5.75.99-7.04,2.96-1.26,1.94-1.88,4.89-1.88,8.87v10.27h-5.38v-26.88Z"
      />
      <path
        fill="#F0529C"
        d="M293.18,47.34c-2.76,0-4.95-.7-6.56-2.1-1.58-1.4-2.37-3.33-2.37-5.81,0-2.22.63-4,1.88-5.32,1.29-1.36,3.39-2.29,6.29-2.8l6.72-1.13c1.33-.22,2.28-.56,2.85-1.02.61-.47.91-1.16.91-2.1,0-1.33-.45-2.33-1.34-3.01-.86-.72-2.38-1.08-4.57-1.08s-3.84.43-4.95,1.29c-1.07.86-1.69,2.15-1.83,3.87h-5.38c.03-2.9,1.09-5.18,3.17-6.83,2.08-1.65,5-2.47,8.76-2.47s6.36.75,8.23,2.26c1.9,1.51,2.85,3.53,2.85,6.08v13.33c0,1.97.09,4.01.27,6.13h-4.89c-.21-2.11-.32-4.14-.32-6.08-.61,1.94-1.72,3.55-3.33,4.84-1.61,1.29-3.75,1.94-6.4,1.94ZM294.31,43.2c2.72,0,4.84-.9,6.35-2.69,1.51-1.83,2.26-4.14,2.26-6.94v-1.61c-.65.47-1.34.84-2.1,1.13-.75.25-1.65.5-2.69.75l-3.71.86c-1.69.39-2.9.95-3.66,1.67-.75.68-1.13,1.63-1.13,2.85s.41,2.24,1.24,2.96c.86.68,2.01,1.02,3.44,1.02Z"
      />
      <path fill="#F0529C" d="M272.95,9.01h5.38v37.64h-5.38V9.01Z" />
      <path
        fill="#F0529C"
        d="M253.49,47.5c-3.01,0-5.56-.63-7.64-1.88-2.08-1.25-3.64-2.96-4.68-5.11-1.04-2.19-1.56-4.64-1.56-7.37s.52-5.11,1.56-7.26c1.04-2.15,2.6-3.85,4.68-5.11s4.62-1.88,7.64-1.88,5.56.63,7.63,1.88,3.64,2.98,4.68,5.16c1.04,2.15,1.56,4.55,1.56,7.2s-.52,5.13-1.56,7.31c-1.04,2.15-2.6,3.87-4.68,5.16-2.08,1.25-4.62,1.88-7.63,1.88ZM245.05,33.2c0,3.55.66,6.11,1.99,7.69,1.36,1.54,3.51,2.31,6.45,2.31s5.07-.77,6.4-2.31c1.36-1.58,2.04-4.14,2.04-7.69s-.68-6.09-2.04-7.64c-1.33-1.58-3.46-2.37-6.4-2.37s-5.09.79-6.45,2.37c-1.33,1.54-1.99,4.09-1.99,7.64Z"
      />
      <path
        fill="#F0529C"
        d="M209.73,9.01h5.38v16.78c1.86-4.59,5.11-6.88,9.73-6.88,3.48,0,5.97.91,7.47,2.74,1.54,1.83,2.31,4.57,2.31,8.23v16.78h-5.38v-16.29c0-2.62-.52-4.43-1.56-5.43-1.04-1.04-2.51-1.56-4.41-1.56-2.72,0-4.77.95-6.13,2.85-1.36,1.9-2.04,4.93-2.04,9.09v11.35h-5.38V9.01Z"
      />
      <path
        fill="#F0529C"
        d="M177.5,33.2c0-2.72.52-5.16,1.56-7.31,1.08-2.15,2.63-3.85,4.68-5.11,2.08-1.25,4.59-1.88,7.53-1.88,4.05,0,7.17,1,9.36,3.01,2.22,1.97,3.41,4.61,3.55,7.9h-5.05c-.25-1.97-.99-3.57-2.2-4.79-1.22-1.22-3.03-1.83-5.43-1.83-2.76,0-4.87.79-6.34,2.37-1.47,1.54-2.2,4.09-2.2,7.64s.72,6.15,2.15,7.69c1.43,1.54,3.53,2.31,6.29,2.31,2.47,0,4.36-.63,5.65-1.88,1.33-1.29,2.11-2.98,2.37-5.05h5.05c-.07,2.04-.63,3.93-1.67,5.65-1,1.68-2.47,3.05-4.41,4.09-1.94,1-4.27,1.51-6.99,1.51-2.94,0-5.45-.63-7.53-1.88-2.08-1.25-3.66-2.96-4.73-5.11s-1.61-4.59-1.61-7.31Z"
      />
      <path
        fill="#F0529C"
        d="M148.7,34.65c.18,5.7,3.62,8.55,10.32,8.55,3.37,0,5.7-.52,6.99-1.56,1.29-1.04,1.94-2.56,1.94-4.57,0-1.65-.5-2.94-1.51-3.87-.97-.97-2.47-1.6-4.52-1.88l-8.28-1.18c-6.17-.86-9.25-4.07-9.25-9.62,0-3.15,1.18-5.7,3.55-7.63,2.37-1.97,5.84-2.96,10.43-2.96s8.35,1.06,10.75,3.17c2.44,2.08,3.78,4.84,4.03,8.28h-5.38c-.29-2.26-1.2-4.01-2.74-5.27-1.54-1.25-3.78-1.88-6.72-1.88s-4.89.56-6.29,1.67c-1.36,1.08-2.04,2.56-2.04,4.46,0,1.36.39,2.49,1.18,3.39.79.86,1.99,1.42,3.6,1.67l8.76,1.29c3.26.47,5.74,1.49,7.42,3.06,1.72,1.54,2.58,3.75,2.58,6.61,0,7.42-4.84,11.13-14.52,11.13-5.45,0-9.43-1.2-11.94-3.6-2.51-2.44-3.76-5.52-3.76-9.25h5.38Z"
      />
      <path
        fill="#F0529C"
        d="M96.31,42.18l18.28-14.79c1.51-1.22,2.53-2.35,3.06-3.39.57-1.04.86-2.26.86-3.66,0-1.76-.57-3.17-1.72-4.25-1.11-1.08-2.85-1.61-5.22-1.61-3.33,0-5.77.95-7.31,2.85-1.51,1.86-2.26,4.46-2.26,7.8h-5.81c.07-4.19,1.27-7.78,3.6-10.75,2.33-2.98,6.25-4.46,11.78-4.46,4.44,0,7.67.99,9.68,2.96,2.04,1.97,3.06,4.44,3.06,7.42,0,2.33-.7,4.48-2.1,6.45-1.4,1.97-3.75,4.25-7.04,6.83l-10.91,8.6h20.7v4.46h-28.66v-4.46Z"
      />
      <path
        fill="#F0529C"
        d="M89.5,46.64h-5.38v-20.97c0-.39-.09-.66-.27-.81-.14-.18-.41-.27-.81-.27h-3.55v-4.84h4.09c1.76,0,3.17.54,4.25,1.61,1.08,1.04,1.63,2.42,1.67,4.14v21.13ZM82.08,10.89h6.77v4.84h-6.77v-4.84Z"
      />
      <path
        fill="#F0529C"
        d="M72.56,46.64l-3.17-8.5h-17.31l-3.17,8.5h-5.59l13.28-35.76h8.33l13.28,35.76h-5.65ZM53.74,33.68h13.98l-6.99-18.87-6.99,18.87Z"
      />
    </svg>
  );
}
